<template>
    <div>
        <Nav :isDark.sync="this.isDark" @darkmode="isDark = $event"></Nav>
        <div class="container py-2" style="height: calc(100vh - 129px);">
            <div>
                <h1 class="fs-18 text-center my-4">国家数据编辑</h1>
                <div class="d-flex flex-column align-items-start">
                    <div class="d-flex">
                        <div class="d-flex flex-column mt-4 me-2">
                            <h4 class="fs-14 mb-0">创建国家：</h4>
                            <el-form class="d-flex demo-ruleForm my-3" ref="form" :rules="rules" :model="form" label-width="60px">
                                <el-form-item label="id" prop="id" style="margin-left: -15px;">
                                    <el-input v-model="form.id" :clearable=true></el-input>
                                </el-form-item>
                                <el-form-item label="国家" prop="name">
                                    <el-input v-model="form.name" :clearable=true></el-input>
                                </el-form-item>
                                <el-form-item>
                                    <el-button type="primary" style="margin-left: -50px;" @click="onSubmit('form')">添加国家</el-button>
                                </el-form-item>
                            </el-form>
                        </div>
                        <div class="d-flex flex-column mt-4 ms-2">
                            <h4 class="fs-14 mb-0">创建联赛：</h4>
                            <el-form class="d-flex demo-ruleForm my-3" ref="formLg" :rules="rulesLg" :model="formLg" label-width="60px">
                                <el-form-item label="id" prop="id" style="margin-left: -15px;">
                                    <el-input v-model="formLg.id" :clearable=true></el-input>
                                </el-form-item>
                                <el-form-item label="联赛" prop="name">
                                    <el-input v-model="formLg.name" :clearable=true></el-input>
                                </el-form-item>
                                <el-form-item label="国id" prop="name">
                                    <el-input v-model="formLg.country_id" :clearable=true></el-input>
                                </el-form-item>
                                <el-form-item>
                                    <el-button type="primary" style="margin-left: -50px;" @click="createLeague('formLg')">添加联赛</el-button>
                                </el-form-item>
                            </el-form>
                        </div>
                    </div>
                    <div class="d-flex align-items-center">
                        <h4 class="fs-14 me-3 mb-0">国家:</h4>
                        <el-autocomplete
                            class="inline-input"
                            v-model="countryName"
                            :fetch-suggestions="countrySearch"
                            :clearable = true
                            placeholder="选择国家"
                            @select="selectCountry"
                        ></el-autocomplete>
                        <div class="ms-3"></div>
                        <h4 class="fs-14 me-3 mb-0">联赛:</h4>
                        <el-autocomplete
                            class="inline-input"
                            v-model="leagueName"
                            :fetch-suggestions="leagueSearch"
                            :clearable = true
                            placeholder="选择联赛"
                            @select="selectLeague"
                        ></el-autocomplete>
                    </div>
                </div>
            </div>
            <Footer></Footer>
        </div>
    </div>
</template>
<script>
import Nav from '../comment/nav.vue'
import Footer from '../comment/footer.vue'
import { createCountryUrl, createFbLeagueUrl, getCountryListUrl, getFbLeagueCountryListUrl } from '../../constants/http.config';
export default {
    components: { Nav,Footer },
    data(){
        return {
            countryName: '',
            leagueName: '',
            radio: 'fb',
            selectName: '选择联赛',
            drawdownList: [],
            leagueDrawdownList: [],
            countryList: [],
            isMobile: false,
            isDark: false,
            form: {
                id: '',
                name: ''
            },
            formLg: {
                id: '',
                name: '',
                cid: ''
            },
            rules: {
                id: [
                    { required: true, message: '请输入id', trigger: 'blur' },
                ],
                name: [
                    { required: true, message: '请输入国家名', trigger: 'blur' }
                ]
            },
            rulesLg: {
                id: [
                    { required: true, message: '请输入id', trigger: 'blur' },
                ],
                name: [
                    { required: true, message: '请输入联赛名', trigger: 'blur' }
                ],
                country_id: [
                    { required: true, message: '请输入国家id', trigger: 'blur' }
                ]
            }
        }
    },
    mounted() {
        this.getCountryList();
        // this.isMobile = checkDevice();        
    },
    methods: {
        getCountryList(){
            console.log('getCountryList');
            
            let url = '';
            if (this.radio === 'fb') {
                url = getCountryListUrl;
            }else{
                url = '/basketball/country/list';
            }
            fetch(url)
            .then(response => response.json())
            .then(data => {
                console.log('data',data.data);
                this.countryList = data.data;
                for (let index = 0; index < data.data.length; index++) {
                    const elm = data.data[index];
                    this.drawdownList.push({
                        value: elm.name,
                        id: elm.id,
                    })
                }
                console.log('drawdownList',this.drawdownList);
            }).catch(err=>{
                console.log(err);
            })
        },
        selectCountry(command){
            let url = getFbLeagueCountryListUrl
            const cid = command.id;
            console.log(cid);
            
            if (this.radio == 'fb') {
                this.selectName = command.name
            }
            fetch(getFbLeagueCountryListUrl + 'country_id=' + cid)
            .then(response => response.json())
            .then(data => {
                console.log('data',data.data);
            }).catch(err=>{
                console.log(err);
            })
        },
        selectLeague(){},
        countrySearch(queryString, cb){
            var countryList = this.drawdownList;
            var results = queryString ? countryList.filter(this.createFilter(queryString)) : countryList;
            cb(results);
        },
        leagueSearch(queryString, cb){
            var leagueList = this.leagueDrawdownList;
            var results = queryString ? leagueList.filter(this.createFilter(queryString)) : leagueList;
            cb(results);
        },
        onSubmit(formName){
            console.log(this.form);
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    // this.$message.error('添加的id、国家名不能为空!');
                    // // const url = '/league/create';
                    fetch(createCountryUrl,{
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(this.form)
                    })
                    .then(response => response.json())
                    .then(data => {
                        // console.log(data);
                        if (data.code === 200) {
                            this.$notify({
                                title: '成功',
                                message: data.msg,
                                type: 'success'
                            });
                        }else{
                            this.$notify.error({
                                title: '失败',
                                message: data.result
                            });
                        }
                    })
                    .catch(error => {
                        console.error('Error:', error);
                        this.$notify.error({
                            title: '错误',
                            message: '添加联赛出错'
                        });
                    });
                } else {
                    this.$message.error('添加的id、国家不能为空!');
                }
            })
        },
        createLeague(formName){
            console.log(this.formLg);
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    // const url = createFbLeagueUrl;
                    fetch(createFbLeagueUrl,{
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(this.formLg)
                    })
                    .then(response => response.json())
                    .then(data => {
                        // console.log(data);
                        if (data.code === 200) {
                            this.$notify({
                                title: '成功',
                                message: data.msg,
                                type: 'success'
                            });
                        }else{
                            this.$notify.error({
                                title: '失败',
                                message: data.result
                            });
                        }
                    })
                    .catch(error => {
                        console.error('Error:', error);
                        this.$notify.error({
                            title: '错误',
                            message: '添加联赛出错'
                        });
                    });
                } else {
                    this.$message.error('添加的id、联赛名、国家id不能为空!');
                }
            })
        }
    }
}
</script>
<style lang="scss" scoped>
    @import '../../assets/sass/global.scss';
</style>